// Marketing copy for each real DeepMagic app. Falls back to a category
// profile for apps not listed here.

const appProfiles = {
  'ai-blog': {
    problem: 'AI news moves faster than any human editor can summarize it.',
    features: ['Deep-researched posts', 'EN / zh-TW bilingual', 'Fresh every 30 min'],
    useCases: ['Morning AI briefing', 'Catch up after a weekend', 'zh-TW readers tracking EN sources'],
    audience: 'Builders and founders tracking AI without doomscrolling'
  },
  'ai-story': {
    problem: 'Long-form worldbuilding rarely gets the visual treatment it deserves.',
    features: ['Illustrated chapter gallery', 'Six-realm story bible', 'AI-art visual pass'],
    useCases: ['Read the saga', 'Browse realm artwork', 'Follow new chapters'],
    audience: 'Fantasy readers and anyone curious what AI storytelling looks like'
  },
  chat: {
    problem: 'Model chatrooms are either locked behind someone else\'s cloud or a mess to host.',
    features: ['Multi-model conversations', 'Prompt library', 'Self-hosted accounts'],
    useCases: ['Daily LLM chat', 'Compare model answers', 'Shared team prompts'],
    audience: 'Anyone on the platform who talks to models daily'
  },
  outline: {
    problem: 'Platform knowledge scattered across chat logs quietly rots.',
    features: ['Full-text search', 'Structured docs', 'Team access control'],
    useCases: ['Deployment runbooks', 'Spec archive', 'Decision records'],
    audience: 'Humans and agents maintaining the platform'
  },
  files: {
    problem: 'Moving files between a phone, a laptop, and a server should not need three tools.',
    features: ['Browser upload & preview', 'Public share links', 'JWT REST API'],
    useCases: ['Drop a spec for an agent', 'Share a build artifact', 'Scripted uploads'],
    audience: 'Anyone exchanging files with the platform'
  },
  hello: {
    problem: 'A multi-app reverse proxy fails silently unless something watches it.',
    features: ['DNS + routing proof', 'HTTPS handshake check', 'Zero-dependency page'],
    useCases: ['Smoke-test after deploys', 'Verify wildcard TLS', 'Debug DNS changes'],
    audience: 'The platform itself — and anyone debugging it'
  }
};

const categoryProfiles = {
  'AI & ML': {
    problem: 'AI workflows need interfaces, not just terminals.',
    features: ['Model-powered workflows', 'Structured outputs', 'Bilingual where it counts'],
    useCases: ['Research', 'Writing', 'Conversation'],
    audience: 'Builders working with LLMs'
  },
  Productivity: {
    problem: 'Team knowledge deserves better than a scrollback.',
    features: ['Searchable knowledge', 'Structured docs', 'Access control'],
    useCases: ['Documentation', 'Onboarding', 'Decision log'],
    audience: 'Small teams and solo builders'
  },
  'Dev Tools': {
    problem: 'Infrastructure needs cheap, obvious proof that it works.',
    features: ['Instant inspection', 'Zero setup', 'Honest output'],
    useCases: ['Smoke testing', 'Debugging', 'Verification'],
    audience: 'Operators and developers'
  },
  Utilities: {
    problem: 'Small recurring frictions add up.',
    features: ['Single-purpose flow', 'Fast results', 'API-first'],
    useCases: ['File exchange', 'Quick sharing', 'Automation glue'],
    audience: 'Anyone on the platform'
  }
};

export const getAppMarketing = (app) => {
  const profile = appProfiles[app.id] || categoryProfiles[app.category] || categoryProfiles['AI & ML'];

  return {
    problem: profile.problem,
    features: profile.features,
    useCases: profile.useCases,
    audience: profile.audience,
    outcome: `${app.name} — ${app.tagline.toLowerCase()}.`
  };
};
